// @ts-nocheck
import React from "react";
import { ArrowLeft, XLg } from 'react-bootstrap-icons';
import { FullScreenModal } from "../../../libs/common/modal";
import * as Styled from "./FullScreenModal.styled";
import { ILiveStream, IMemberPlans, LiveLayoutModalProps } from "../../../types";
import { EventCard } from "../EventCard";
import { ToggleFilter } from "../../layouts-live-stream/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";

type LayoutModalInternalProps = Omit<LiveLayoutModalProps, 'visibleCount' | 'onScroll'> & {
    activePlans: IMemberPlans[];
    hasFullAccess: boolean;
    freeTrialPlanIds: string[];
    onWatchClick: (event: ILiveStream) => void;
    isMobile?: boolean;
};

const LayoutModal: React.FC<LayoutModalInternalProps> = ({
    show,
    onHide,
    filteredLiveEvents,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick,
    isMobile = false,
}) => {
    const [visibleCount, setVisibleCount] = React.useState(30);
    const [selectedOption, setSelectedOption] = React.useState<'All' | 'Free' | 'Premium'>('All');

    React.useEffect(() => {
        if (show) setVisibleCount(30);
    }, [show]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        const scrollPosition = target.scrollTop + target.clientHeight;
        const threshold = 100;

        if (scrollPosition + threshold >= target.scrollHeight && visibleCount < filteredLiveEvents.length) {
            setVisibleCount((prev) => prev + 10);
        }
    };

    const filteredEvents = filterEventsByType(filteredLiveEvents, selectedOption);

    return (
        <FullScreenModal
            show={show}
            onHide={onHide}
            zIndex={999999990}
            header={
                <Styled.ModalHeader $isMobile={isMobile}>
                    {isMobile ? (
                        <>
                            <Styled.MobileHeaderTopRow>
                                <Styled.TitleContainer $isMobile={true}>
                                    Live Events
                                    <Styled.VideoCountMobile>
                                        ({Math.min(visibleCount, filteredEvents.length)} of {filteredEvents.length} Live Streams)
                                    </Styled.VideoCountMobile>
                                </Styled.TitleContainer>
                                <Styled.BackArrow onClick={onHide}>
                                    <XLg size={23} />
                                </Styled.BackArrow>
                            </Styled.MobileHeaderTopRow>
                            <Styled.MobileFilterRow>
                                <ToggleFilter
                                    selectedOption={selectedOption}
                                    onChange={setSelectedOption}
                                />
                            </Styled.MobileFilterRow>
                        </>
                    ) : (
                        <>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Styled.BackArrow onClick={onHide}>
                                    <ArrowLeft size={23} />
                                </Styled.BackArrow>
                                <Styled.TitleContainer>
                                    Live Streams
                                    <Styled.VideoCount>
                                        ({Math.min(visibleCount, filteredEvents.length)} of {filteredEvents.length} Live Streams)
                                    </Styled.VideoCount>
                                </Styled.TitleContainer>
                            </div>
                            <ToggleFilter
                                selectedOption={selectedOption}
                                onChange={setSelectedOption}
                            />
                        </>
                    )}
                </Styled.ModalHeader>
            }
        >
            <Styled.ScrollableContent onScroll={handleScroll}>
                {filteredEvents.length === 0 ? (
                    <Styled.EmptyStateMessage>
                        There are no events currently streaming. Please check back later for updates.
                    </Styled.EmptyStateMessage>
                ) : (
                    <Styled.MediaGrid $isMobile={isMobile}>
                        {filteredEvents.slice(0, visibleCount).map((item, index) => {

                            const hasEligiblePlan =
                                isSignedIn &&
                                ((
                                    !!item.planDetails.length
                                        ? !!activePlans.filter((memberPlan) =>
                                            item.planDetails.some(
                                                (itemPlan) => itemPlan?.id === memberPlan.id
                                            )
                                        ).length
                                        : true
                                ) ||
                                freeTrialPlanIds.includes(item.id) ||
                                hasFullAccess);

                            return (
                                <EventCard
                                    key={index}
                                    event={item}
                                    isSignedIn={isSignedIn}
                                    hasEligiblePlan={hasEligiblePlan}
                                    onWatchClick={onWatchClick}
                                />
                            );
                        })}
                    </Styled.MediaGrid>
                )}
            </Styled.ScrollableContent>
        </FullScreenModal>
    );
};

export default LayoutModal;